import { Box, BoxProps, IconButton, styled } from '@mui/material';
import { gradients } from 'style/colors';

export const DropzoneOuterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(8),
  gap: theme.spacing(5),
}));

export const DropzoneContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '200px',

  [theme.breakpoints.down('md')]: {
    width: '315px',
  },

  [theme.breakpoints.up('md')]: {
    width: '520px',
  },
}));

export const PreviewsOuterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  gap: '14px',

  [theme.breakpoints.down('md')]: {
    width: '315px',
  },

  [theme.breakpoints.up('md')]: {
    width: '520px',
  },
}));

export const PreviewsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  background: theme.palette.background.secondary,
  borderRadius: 5,
  height: '114px',
  padding: theme.spacing(4),
  gap: theme.spacing(4),

  [theme.breakpoints.down('md')]: {
    width: '315px',
  },

  [theme.breakpoints.up('md')]: {
    width: '520px',
  },
}));

interface DropzoneBoxProps extends BoxProps {
  isFocused: boolean;
  disabled: boolean;
  error?: boolean;
}

export const StyledDropzone = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFocused' && prop !== 'disabled' && prop !== 'error',
})<DropzoneBoxProps>(({ theme, isFocused, disabled, error }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(7),
  background: gradients.dropzone,
  boxShadow: `0px 0px 6px ${
    error ? theme.palette.text.error : theme.palette.primary.main
  }`,
  outline: 0,
  borderRadius: 5,
  border: '2px solid',
  borderColor: error
    ? 'transparent'
    : isFocused
      ? theme.palette.primary.dark
      : theme.palette.common.black,
  cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.6 : 1,
}));

export const LabelWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.textXl.fontSize,
  textTransform: 'none',
  textAlign: 'center',
  '& > svg': {
    width: ' 20px',
    height: '20px',
    marginRight: theme.spacing(4),
  },
}));

export const PreviewContainer = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  width: '94px',
  height: '94px',
  border: `2px solid ${theme.palette.border.tertiary}`,
}));

export const RemoveButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  position: 'absolute',
  width: '24px',
  height: '24px',
  top: '2px',
  right: '2px',
  borderRadius: '50%',
  border: `1px solid ${theme.palette.border.tertiary}`,
  backgroundColor: theme.palette.background.main,
  '&:hover': {
    boxShadow: `0px 1px 10px ${theme.palette.primary.main}`,
  },
}));

export const RemoveButton = styled(IconButton)({
  '> svg': {
    width: '12px',
    height: '12px',
  },
});
